import { api } from './client'
import type { AvatarPresetId } from '../avatarPresets'
import type { ChipLedger, GameweekResult } from '../types'
import type { OtherPlayerGameweekPicks } from '../otherPlayerReveal'

/** The live, user-chosen identity fields for another player —
 * read when viewing their profile so their current avatar and favourite team
 * show, rather than a device-local guess or static mock roster value. Their
 * real, scored `seasonHistory` drives the profile's stats so
 * they follow the dev-tool simulation — empty until simulated, zeroed by a reset. */
export interface PlayerPublicProfile {
  userId: string
  displayName: string
  favouriteTeam: string | null
  avatarPreset: AvatarPresetId | null
  seasonHistory: GameweekResult[]
  /** Their own chip ledger — optional so an older server that doesn't send it
   *  leaves the profile's Chips row empty rather than falling back to the viewer's chips. */
  chipsUsed?: ChipLedger
}

export function loadPlayerProfile(userId: string): Promise<PlayerPublicProfile> {
  return api.get(`/players/${encodeURIComponent(userId)}`)
}

/** Another player's real picks (predictions, banker, chip, quests) for one already-concluded
 * gameweek — the "GW N Calls" reveal, sourced from their simulated rows. */
export function loadPlayerGameweekPicks(
  userId: string,
  gameweek: number
): Promise<OtherPlayerGameweekPicks> {
  return api.get(`/players/${encodeURIComponent(userId)}/picks/${gameweek}`)
}
